/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-console */
import { FC, ReactNode, useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Container } from '@components/design-system';
import { MOBILE_OFFSET } from '@constants';
import { logout } from '@lib/beacon';
import { actions as authActions } from '@state/auth';
import { actions } from '@state/global';
import { RootState } from '@state/store';

interface IMobileSlider {
  children?: ReactNode;
}

// TODO: change this from mouse to touch events
const SIZE = 180;

const preventDefault = (rawEvent: any) => {
  const e = rawEvent || window.event;
  if (e.touches.length > 1) {
    return true;
  }

  if (e.preventDefault) {
    e.preventDefault();
  }

  return false;
};

const lock = () => {
  document.body.classList.add('lock');
  document.addEventListener('touchmove', preventDefault, { passive: false } as any);
};

const unlock = () => {
  document.body.classList.remove('lock');
  document.removeEventListener('touchmove', preventDefault, { passive: false } as any);
};

export const MobileSlider: FC<IMobileSlider> = ({ children }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const [mobile, setMobile] = useState<boolean | undefined>(false);
  const { mobileOffset } = useSelector((state: RootState) => state.global);

  const viewer = user?.id;

  const handleClose = () => {
    dispatch({ type: actions.GLOBAL_MOBILE_OFFSET, payload: MOBILE_OFFSET.CENTER });
  };

  const handleLogout = async () => {
    await logout();
    dispatch({ type: authActions.AUTH_LOGOUT });
  };

  useEffect(() => {
    setMobile(window.innerWidth < 640);

    const resize = () => {
      if (window.innerWidth < 640) {
        setMobile(true);
      } else {
        setMobile(false);
        dispatch({ type: actions.GLOBAL_MOBILE_OFFSET, payload: MOBILE_OFFSET.CENTER });
      }
    };

    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  useEffect(() => {
    if (mobile) {
      if (mobileOffset === 0) {
        unlock();
      } else {
        lock();
      }
    }
  }, [mobile, mobileOffset]);

  const handleReset = async () => {
    dispatch({ type: actions.GLOBAL_MOBILE_OFFSET, payload: MOBILE_OFFSET.CENTER });
  };

  if (mobile) {
    return (
      <Box
        css={{
          display: 'block',
        }}
      >
        {/* LEFT MENU */}
        <Box
          css={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: SIZE,
            height: '100%',
          }}
        >
          <Box css={{ flexDirection: 'column', width: '100%', height: '100%' }}>
            {/* TOP */}
            <Container>
              <Box
                css={{
                  display: 'flex',
                  height: '$space$1',
                  alignItems: 'center',
                }}
              >
                <Button variant="basic" onClick={handleClose}>
                  <Box css={{ width: 36, height: 36 }} vertical horizontal>
                    <i>close</i>
                  </Box>
                </Button>
              </Box>
            </Container>

            {/* MIDDLE */}
            <Container css={{ flex: 1 }}>
              <Box css={{ flexDirection: 'column' }}>
                <Link href={`/user/${viewer}/created`} locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Profile
                  </Button>
                </Link>

                <Link href="/dashboard" locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Dashboard
                  </Button>
                </Link>

                <Link href="/settings" locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Settings
                  </Button>
                </Link>
              </Box>
            </Container>

            {/* BOTTOM */}
            <Box css={{ borderTop: '1px solid $primaryBorder' }}>
              <Container css={{ display: 'flex' }}>
                <Button
                  as="a"
                  variant="basic"
                  css={{
                    padding: '$space$3 0',
                    fontSize: 16,
                    width: '100%',

                    '@bp1': {
                      fontSize: 14,
                    },
                  }}
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </Container>
            </Box>
          </Box>
        </Box>

        {/* RIGHT SIDE */}
        <Box
          css={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: SIZE,
            height: '100%',
          }}
        >
          <Box css={{ flexDirection: 'column', width: '100%', height: '100%' }}>
            {/* TOP */}
            <Container>
              <Box
                css={{
                  display: 'flex',
                  height: '$space$1',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                <Button
                  variant="basic"
                  onClick={handleClose}
                  css={{
                    width: 34,
                    height: 34,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Box vertical horizontal>
                    <i>close</i>
                  </Box>
                </Button>
              </Box>
            </Container>

            {/* MIDDLE */}
            <Container css={{ flex: 1 }}>
              <Box css={{ flexDirection: 'column' }}>
                {viewer && (
                  <Link href="/mint" locale={router.locale} prefetch={false} passHref>
                    <Button
                      as="a"
                      variant="basic"
                      css={{
                        padding: '$space$3 0',
                        fontSize: 16,
                        '@bp1': {
                          fontSize: 14,
                        },
                      }}
                      onClick={handleClose}
                    >
                      Mint
                    </Button>
                  </Link>
                )}

                <Link href="/boards" locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Boards
                  </Button>
                </Link>

                <Link href="/collections" locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Collections
                  </Button>
                </Link>

                <Link href="/explore" locale={router.locale} prefetch={false} passHref>
                  <Button
                    as="a"
                    variant="basic"
                    css={{
                      padding: '$space$3 0',
                      fontSize: 16,
                      '@bp1': {
                        fontSize: 14,
                      },
                    }}
                    onClick={handleClose}
                  >
                    Explore
                  </Button>
                </Link>
              </Box>
            </Container>
            {/* BOTTOM */}
            <Box>&nbsp;</Box>
          </Box>
        </Box>

        {/* CONTENT */}
        <Box
          css={{
            display: 'block',
            pointerEvents: 'none',
            backgroundColor: '$primaryBackground',
            transform: `translateX(${mobileOffset * -SIZE}px)`,
            transition: 'transform 0.3s cubic-bezier(0.2,0.5,0.3,1)',
          }}
        >
          {children}
        </Box>

        {/* SHADOW */}
        <Box
          css={{
            display: 'block',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            transform: `translateX(${mobileOffset * -SIZE}px)`,
            transition: 'transform 0.3s cubic-bezier(0.2,0.5,0.3,1),opacity 0.3s cubic-bezier(0.2,0.5,0.3,1)',
            backgroundColor: 'black',
            opacity: mobileOffset === MOBILE_OFFSET.CENTER ? 0 : 0.6,
            pointerEvents: mobileOffset === MOBILE_OFFSET.CENTER ? 'none' : 'all',
          }}
          onClick={handleReset}
        />
      </Box>
    );
  }

  // DESKTOP
  return <span>{children}</span>;
};
